<template>
  <div id="userLogin" class="login-container">
    <div class="card-wrapper">
      <h2 class="title">
        <i class="iconfont icon-search"></i>
        <span>查询退款进度专用链接</span>
      </h2>
      <form class="query-form">
        <div class="input-wrap">
          <i class="iconfont icon-card"></i>
          <input 
            type="text" 
            v-model="iccid" 
            placeholder="请输入卡号咨询" 
            autofocus 
            class="iccid-input"
          />
        </div>
        <div class="formLine">
          <mt-button 
            type="primary" 
            style="background:#0066FF" 
            size="large" 
            @click.prevent="userQuerySIM"
            class="query-btn">
            <i class="iconfont icon-search"></i>
            查 询
          </mt-button>
        </div>

        <!-- 优化后的退款进度展示区域 -->
        <div v-if="backDay !== ''" class="progress-card">
          <div class="progress-header">
            <div class="progress-title">退款进度查询结果</div>
            <div class="progress-subtitle">卡号: {{ iccid }}</div>
          </div>
          
          <!-- 进度条可视化 -->
          <div class="progress-bar-container">
            <div 
              class="progress-bar" 
              :style="{ width: getProgressWidth + '%', backgroundColor: getProgressColor }"
            ></div>
            <div class="progress-steps">
              <div class="step" :class="{ active: backDay > 0 }">
                <div class="step-dot"></div>
                <div class="step-text">已提交</div>
              </div>
              <div class="step" :class="{ active: backDay > 1 }">
                <div class="step-dot"></div>
                <div class="step-text">系统审核</div>
              </div>
              <div class="step" :class="{ active: backDay > 4 }">
                <div class="step-dot"></div>
                <div class="step-text">财务审核</div>
              </div>
              <div class="step" :class="{ active: backDay > 10 }">
                <div class="step-dot"></div>
                <div class="step-text">打款排队</div>
              </div>
            </div>
          </div>
          
          <!-- 进度详情 -->
          <div class="progress-detail">
            <div class="detail-item">
              <span class="label">当前状态：</span>
              <span class="value" :style="{ color: getProgressColor }">
                <span v-if="backDay <= 1">已提交</span>
                <span v-else-if="backDay > 1 && backDay <= 4">系统审核中</span>
                <span v-else-if="backDay > 4 && backDay <= 10">财务审核中</span>
                <span v-else>打款排队中</span>
              </span>
            </div>
            <!-- <div class="detail-item" v-if="backDay > 10">
              <span class="label">排队人数：</span>
              <span class="value queue-number">{{ queueNumber }} 人</span>
            </div> -->
            <!-- <div class="detail-item">
              <span class="label">预计完成时间：</span>
              <span class="value">{{ getEstimatedTime }}</span>
            </div> -->
          </div>
          
          <!-- 温馨提示 -->
          <div class="progress-tips">
            <i class="iconfont icon-tips"></i>
            <span>退款进度会实时更新，请耐心等待，如有疑问请联系客服</span>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      iccid: "",
      code: "",
      showAds: true,
      gzh: "",
      backDay: "", //退款天数
      queueNumber: 0 //排队人数
    };
  },
  computed: {
    // 计算进度条宽度
    getProgressWidth() {
      if (this.backDay <= 1) return 25;
      if (this.backDay > 1 && this.backDay <= 4) return 50;
      if (this.backDay > 4 && this.backDay <= 10) return 75;
      return 100;
    },
    // 进度条颜色
    getProgressColor() {
      if (this.backDay <= 1) return "#409EFF";
      if (this.backDay > 1 && this.backDay <= 4) return "#67C23A";
      if (this.backDay > 4 && this.backDay <= 10) return "#E6A23C";
      return "#F56C6C";
    },
    // 预计完成时间
    getEstimatedTime() {
      const today = new Date();
      let daysToAdd = 0;
      
      if (this.backDay <= 1) daysToAdd = 10;
      else if (this.backDay > 1 && this.backDay <= 4) daysToAdd = 7;
      else if (this.backDay > 4 && this.backDay <= 10) daysToAdd = 3;
      else daysToAdd = this.queueNumber > 50 ? 5 : 2;
      
      today.setDate(today.getDate() + daysToAdd);
      return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    }
  },
  methods: {
  userQuerySIM() {
  if (!this.iccid || this.iccid == "") {
    Dialog.alert({ title: "提示", message: "请输入ICCID号" });
    return false;
  }

  let data = {
    iccid: this.iccid
  };
  wxRequest("applyChangeSim/selectBackState", data, "post").then((res) => {
    if (res.data.code == 200) {
      this.backDay = res.data.data;
      // 模拟生成排队人数
      if (this.backDay > 10) {
        this.queueNumber = Math.floor(Math.random() * 999) + 1;
      }
      // 滚动到进度区域（修改后的代码）
      setTimeout(() => {
        const progressCard = document.querySelector('.progress-card');
        if (progressCard) {
          progressCard.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
    } else {
      Dialog.alert({ title: "提示", message: res.data.message });
    }
  });
},

    // 补充autocomplete必需的方法
    querySearch(queryString, cb) {
      cb([]);
    },
    handleSelect(item) {
      this.iccid = item;
    }
  },
  created() {
    var appid = process.env.VUE_APP_APPID;
    localStorage.setItem("appid", appid);
    localStorage.setItem("isHeadquarterAppid", true);
  },
  mounted() { },
  beforeDestroy() { }
};
</script>

<style lang="less" scoped>
// 全局容器样式
.login-container {
  min-height: 100vh;
  background: linear-gradient(120deg, #e6f7ff 0%, #f0f8fb 100%);
  padding: 30px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

// 卡片容器
.card-wrapper {
  width: 100%;
  max-width: 500px;
  background: #fff;
  border-radius: 12px;
  padding: 30px 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

// 标题样式
.title {
  text-align: center;
  color: #303133;
  font-size: 18px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  i {
    margin-right: 8px;
    color: #0066FF;
    font-size: 20px;
  }
  
  span {
    font-weight: 600;
  }
}

// 查询表单样式
.query-form {
  width: 100%;
}

.input-wrap {
  position: relative;
  margin-bottom: 20px;
  
  i {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #909399;
    font-size: 16px;
  }
  
  .iccid-input {
    width: 100%;
    height: 48px;
    padding: 0 15px 0 40px;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    font-size: 15px;
    transition: all 0.3s;
    
    &:focus {
      border-color: #0066FF;
      box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
      outline: none;
    }
  }
}

.formLine {
  margin-bottom: 30px;
  
  .query-btn {
    width: 100%;
    height: 48px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    border: none;
    
    i {
      margin-right: 5px;
    }
  }
}

// 进度卡片样式
.progress-card {
  width: 100%;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  animation: fadeIn 0.5s ease-in-out;
}

// 进度头部
.progress-header {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f2f5;
  
  .progress-title {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
    margin-bottom: 5px;
  }
  
  .progress-subtitle {
    font-size: 13px;
    color: #909399;
  }
}

// 进度条容器
.progress-bar-container {
  margin-bottom: 25px;
  
  .progress-bar {
    height: 6px;
    border-radius: 3px;
    transition: width 0.5s ease-in-out;
    margin-bottom: 15px;
  }
  
  .progress-steps {
    display: flex;
    justify-content: space-between;
    
    .step {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      
      .step-dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #e5e6eb;
        margin-bottom: 8px;
        transition: all 0.3s;
      }
      
      .step-text {
        font-size: 12px;
        color: #909399;
        white-space: nowrap;
      }
      
      &.active {
        .step-dot {
          background: #0066FF;
          box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
        }
        
        .step-text {
          color: #303133;
          font-weight: 500;
        }
      }
    }
  }
}

// 进度详情
.progress-detail {
  margin-bottom: 20px;
  
  .detail-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 14px;
    
    .label {
      color: #606266;
      width: 80px;
      flex-shrink: 0;
    }
    
    .value {
      color: #303133;
      
      &.queue-number {
        color: #F56C6C;
        font-weight: 600;
      }
    }
  }
}

// 温馨提示
.progress-tips {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 13px;
  
  i {
    color: #E6A23C;
    margin-right: 8px;
    margin-top: 2px;
    flex-shrink: 0;
  }
  
  span {
    color: #606266;
    line-height: 1.5;
  }
}

// 动画效果
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 图标样式（可替换为项目实际使用的图标库）
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-search::before { content: "\e60c"; }
.icon-card::before { content: "\e622"; }
.icon-tips::before { content: "\e64a"; }
</style>